<div class="d-flex justify-content-center gap-8">
  <div class="d-flex flex-column align-items-center text-center gap-4">
    <span class="apple-logo ri-apple-fill"></span>
    <div class="d-flex align-items-center gap-4">
      <div class="branch left-branch"></div>
      <span class="achievement-title" i18n="@@socialProofRank1">#1 in the AppStore</span>
      <div class="branch right-branch"></div>
    </div>
    <span class="achievement-subtitle" i18n="@@socialProofCategoryMagazines">
      For Magazines and Newspapers
    </span>
  </div>

  <div class="d-flex flex-column align-items-center text-center gap-4">
    <span class="review-stars">●●●●●</span>

    <div class="d-flex align-items-center gap-4">
      <div class="branch left-branch"></div>
      <span class="achievement-title" i18n="@@socialProofReviewsCount">15,000+ 5 Star Reviews</span>
      <div class="branch right-branch"></div>
    </div>
    <span class="achievement-subtitle" i18n="@@socialProofCountries">In 64 Countries</span>
  </div>
</div>
